import { SearchFilter } from "../internal/searchfilter";

export class SearchFilter_PendingProposals extends SearchFilter {
    HotRequest: boolean;
    
    constructor(){
        super();
        this.HotRequest = null;
    }
}

